import React from "react";
import ArticleCarouselB12 from "../../../stories/Carousel/ArticleCarouselB12";
import article1 from "../../../assets/images/image1.png"
import article2 from "../../../assets/images/image2.png";
import VitaminB12 from "../../../stories/cards/VitaminB12";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import ArticleCard from "../../../stories/cards/ArticleCard";
import { calculateNextTestCountdown } from "../../../utils";
import { logEvent } from "../../../components/Analytics";

const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return "th";

  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const formatDateWithOrdinal = (date) => {
  const d = new Date(date);

  const day = d.getDate();

  return `${day}${getOrdinalSuffix(day)} ${d.toLocaleDateString(
    "en-GB",
    {
      month: "long",
      year: "numeric",
    }
  )}`;
};

const InsightsSection = ({ dateReported, vitaminB12Value }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const timeLeft = calculateNextTestCountdown(
    (dateReported),
    (Number.parseFloat(vitaminB12Value)),
    "Vitamin B12"
  );
  let isLogged = false;
  const hostname = globalThis.location.hostname;
  if (hostname === 'dashboard.myhealthchecked.com') {
    isLogged = true;
  }
  let timeMessage = '';

  if (timeLeft?.months > 0) {
    timeMessage = `${timeLeft?.months} month${timeLeft?.months > 1 ? 's' : ''}`;
  } else {
    timeMessage = `${timeLeft?.weeks} week${timeLeft?.weeks > 1 ? 's' : ''}`;
  }

  const formattedDueDate = timeLeft?.dueDate
  ? formatDateWithOrdinal(timeLeft.dueDate)
  : "";

  const isDueNow = timeLeft?.months === 0 && timeLeft?.weeks === 0;

  return (
    <div>
      {/* <VitaminB12
        heading="DISCOVER MORE"
        bgColor="tranparent"
        showLogo={true}
        color="light"
        isLogged={isLogged}
        title={<span>Are you aware Boots offer a Private Vitamin B12 Service?</span>}
        description={
          <span >
            Are you aware{" "}
            <span className="brand-name">
              <img src={bootsLogo} alt="Boots Logo" className="product-image" />
            </span>{" "}
            have a private Vitamin B12 Service?{" "}
            <a className="fs-5" href="https://www.boots.com/terms-conditions-2#" target="_blank" rel="noopener noreferrer" onClick={(e) => {
              if (isLogged === true) {
                logEvent("button_click", {
                  category: "Vitamin B12 Service T&Cs link",
                  action: "click",
                  label: "T&Cs link",
                });
              }
            }}>T&Cs apply</a>
          </span>
        }
      /> */}
      <div className="row vitamin-b12-section">
        <div className="col-md-7 px-0">
          <h6>DISCOVER MORE</h6>
          {isMobile && (
            <img src={article2} className="mobile-image" alt="article image" />
          )}
          <h3>Are you aware Boots offer a Private Vitamin B12 Service?</h3>
          <a
            className="fs-5"
            href="https://www.boots.com/terms-conditions-2#"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (isLogged === true) {
                logEvent("button_click", {
                  category: "Vitamin B12 Service T&Cs link",
                  action: "click",
                  label: "T&Cs link",
                });
              }
            }}
          >
            T&Cs apply
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.707 6.70597C16.0977 6.3155 16.0977 5.68137 15.707 5.2909L10.7068 0.292854C10.3161 -0.0976181 9.68172 -0.0976181 9.29108 0.292854C8.90043 0.683327 8.90043 1.31745 9.29108 1.70793L12.585 5.00039H1.00005C0.446897 5.00039 0 5.44709 0 6C0 6.55291 0.446897 6.99961 1.00005 6.99961H12.585L9.29108 10.2921C8.90043 10.6825 8.90043 11.3167 9.29108 11.7071C9.68172 12.0976 10.3161 12.0976 10.7068 11.7071L15.707 6.7091V6.70597Z"
                fill="#D9808A"
              />
            </svg>
          </a>
          <ul className="ageo-medium">
            <li className={`d-flex  ${isMobile ? "align-items-start" : "align-items-center"}`}>
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="5" cy="5" r="5" fill="#003032" />
              </svg>
              <span>
                Fast-track vitamin B12 injections at your local Boots pharmacy
              </span>
            </li>
            <li className={`d-flex  ${isMobile ? "align-items-start" : "align-items-center"}`}>
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="5" cy="5" r="5" fill="#003032" />
              </svg>
              <span>Personalised dosing advice from our clinical team</span>
            </li>
            <li className={`d-flex  ${isMobile ? "align-items-start" : "align-items-center"}`}>
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="5" cy="5" r="5" fill="#003032" />
              </svg>
              <span>No GP referral needed — book directly online</span>
            </li>
          </ul>
        </div>
        <div className="col-md-5">
          {!isMobile && <img src={article2} alt="article image" />}
          <button
            className="btn btn-white details-button"
            onClick={(e) => {
              const buttonCategory = "Find out more";
              const buttonLabel = "Find out more button";

              if (isLogged === true) {
                logEvent("button_click", {
                  category: buttonCategory,
                  action: "click",
                  label: buttonLabel,
                });
              }
              const url =
                "https://www.boots.com/healthhub/a-z-services/vitamin-b12-service";

              // Delay to allow GA event to trigger
              setTimeout(() => {
                window.open(url, "_blank");
              }, 500);
            }}
          >
            Book now
          </button>
        </div>
      </div>
      <VitaminB12
        heading="YOUR SCHEDULE"
        bgColor="transparent"
        color="dark"
        isLogged={isLogged}
        title={
          <span className="order-description">
            Your next blood test is due in{" "}
            <strong className="text-danger">{timeMessage}</strong>
          </span>
        }
        description={
          isMobile ? (
            isDueNow ? <span className="schedule-date-text fs-16 ageo-regular">It's time to book your next blood test.</span> : 
            formattedDueDate && (
              <>
                <span className="schedule-date-text fs-16 ageo-regular">
                  {formattedDueDate} — we'll send you a reminder closer to the
                  date.
                </span>
              </>
            )
          ) : (
            <span className="order-description">
              Your next blood test is due in{" "}
              <strong className="text-danger">{timeMessage}</strong>
              {formattedDueDate && (
                <>
                  <br />
                  <span className="schedule-date-text fs-16 ageo-regular">
                    {formattedDueDate} — we'll send you a reminder closer to the
                    date.
                  </span>
                </>
              )}
            </span>
          )
        }
      />
      <section className="insight-learning-section">
        <h6>YOU MIGHT BE INTERESTED TO KNOW</h6>
        <h5>
          <b>Learning something new</b>
        </h5>
        <p>
          Find expert guidance to help you understand and manage your health
          better.
        </p>

        {isMobile ? (
          <ArticleCard />
        ) : (
          <ArticleCarouselB12 article1={article1} article2={article2} />
        )}
      </section>
    </div>
  );
};

InsightsSection.propTypes = {
  dateReported: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  vitaminB12Value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default InsightsSection;